import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-2" }

import Container from '../components/content/Container.vue';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';


export default /*@__PURE__*/_defineComponent({
  __name: 'CsgWaiverScript',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Phone Sales Script:", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "py-2" }, " The CSG requires us to meet performance standards for standard telephone services. The minimum CSG requirements are: ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("ul", null, [
        _createElementVNode("li", null, "(a) Providing written information at least every two years (or upon request at any time) about the CSG performance standards, our obligations and your right to compensation under the CSG;"),
        _createElementVNode("li", null, "(b) Guaranteed maximum periods to connect new services;"),
        _createElementVNode("li", null, "(c) Guaranteed maximum periods for fault rectification;"),
        _createElementVNode("li", null, "(d) Maximum time frames for customer appointments;")
      ], -1)),
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(brandService).getTitle()) + " Talk is a VoIP phone service which is provided over your Internet connection. It is necessary for you to agree to the following Customer Service Guarantee Waiver before we can supply you with the VoIP service you have ordered. You are entitled to change your mind and withdraw your consent within 5 working days, however we are not obligated to supply a service if you choose to do so. ", 1),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "py-2" }, " We need you to do this because we cannot guarantee the date of provisioning or the restoration time of your VoIP service if a fault occurs with the internet or your underlying physical connection that supports your Internet service. ", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "py-2" }, " The wavier means that you cannot claim compensation if we fail to meet set standards for connection times, fault restoration, and appointment times. The wavier does not stop you from contacting us about a fault with your service and we will always do our best to restore or provision your service as quickly as possible. ", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "py-2" }, " Written details of this waiver will be sent via email upon completion of the application. ", -1))
    ]),
    _: 1,
    __: [0,1,2,3,4,5]
  }))
}
}

})